import { z } from "zod";
export const webResearchOperationSchema = z.enum(["search", "fetch"]);
/**
 * Provider usage captured on every successful web-research tool event.
 * Integer micro-USD keeps daily snapshots exact while preserving the
 * provider's estimated dollar cost for later credit or plan conversion.
 */
export const webResearchUsageSchema = z.object({
    provider: z.literal("exa"),
    operation: webResearchOperationSchema,
    requestCount: z.number().int().nonnegative(),
    searchRequestCount: z.number().int().nonnegative(),
    fetchRequestCount: z.number().int().nonnegative(),
    documentCount: z.number().int().nonnegative(),
    contentCharacters: z.number().int().nonnegative(),
    estimatedCostMicrosUsd: z.number().int().nonnegative(),
});
